import { createSlice } from '@reduxjs/toolkit';

const chatMessagesSlice = createSlice({
  name: 'chatMessages',
  initialState: {
    messagesByChatId: {},
    loading: false,
    pageByChatId: {},
    totalPagesByChatId: {},
  },
  reducers: {
    requestChatMessages: (state, action) => {
      const { chatId, pageNumber } = action.payload;
      state.loading = true;
      state.pageByChatId[chatId] = pageNumber;
      if (pageNumber === 1) {
        delete state.messagesByChatId[chatId];
      }
    },
    hydrateChatMessages: (state, action) => {
      const { data: messages, total_pages, chatId, pageNumber } = action.payload;
      state.messagesByChatId[chatId] = messages;
      state.totalPagesByChatId[chatId] = total_pages;
      state.pageByChatId[chatId] = pageNumber;
      state.loading = false;
    },
    appendChatMessages: (state, action) => {
      const { chatId, messages } = action.payload;

      if (!state.messagesByChatId[chatId]) {
        state.messagesByChatId[chatId] = [];
      }

      state.messagesByChatId[chatId] = state.messagesByChatId[chatId].concat(messages);
      state.loading = false;
    },
    appendChatMessage: (state, action) => {
      const { chat_session_id, message } = action.payload;
      const prevMessages = state.messagesByChatId[chat_session_id] || [];
      state.messagesByChatId[chat_session_id] = [...prevMessages, message]; // creates a new array
    },
    clearChatMessages: (state, action) => {
      const { chatId } = action.payload;
      delete state.messagesByChatId[chatId];
      delete state.pageByChatId[chatId];
      delete state.totalPagesByChatId[chatId];
    },
    updateChatMessage: (state, action) => {
      const { chatId, messageId, updatedMessage } = action.payload;
      const messages = state.messagesByChatId[chatId];
      if (messages) {
        const messageIndex = messages.findIndex((msg) => msg.id === messageId);
        if (messageIndex >= 0) {
          messages[messageIndex] = {
            ...messages[messageIndex],
            ...updatedMessage,
          };
        }
      }
    },
    deleteChatMessage: (state, action) => {
      const { chatId, messageId } = action.payload;
      const messages = state.messagesByChatId[chatId];
      if (messages) {
        const messageIndex = messages.findIndex((msg) => msg.id === messageId);
        if (messageIndex >= 0) {
          messages.splice(messageIndex, 1);
        }
      }
    },
    clearAllChatMessages: (state) => {
      state.messagesByChatId = {};
      state.pageByChatId = {};
      state.totalPagesByChatId = {};
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setChatMessages: (state, action) => {
      const { chatId, messages } = action.payload;
      state.messagesByChatId[chatId] = messages;
    },
    setChatMessage: (state, action) => {
      const { chatId, message } = action.payload;
      if (!state.messagesByChatId[chatId]) {
        state.messagesByChatId[chatId] = [];
      }
      state.messagesByChatId[chatId].push(message);
    },

  },
});

export default chatMessagesSlice;
